import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "bt-icon bt-icon--sm" }
const _hoisted_4 = { class: "dialog-custom__content" }
const _hoisted_5 = { class: "list-blocks list-blocks--fill mt-3" }
const _hoisted_6 = { class: "list-blocks__item-head" }
const _hoisted_7 = { class: "bt-icon bt-icon--m" }
const _hoisted_8 = { class: "ml-3 mb-0" }
const _hoisted_9 = { class: "bt-icon bt-icon--xs" }
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = { class: "list-blocks__item-content" }
const _hoisted_12 = {
  key: 0,
  class: "list-unstyled pl-5"
}
const _hoisted_13 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_NewRoomObject = _resolveComponent("NewRoomObject")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    modal: true,
    showHeader: false,
    onHide: _ctx.doHideDialog,
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    class: "dialog-custom dialog-add-object"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('AppResource.AddAnObject')), 1),
        _createVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('ChooseObjectsAddToRoom')) + " ", 1),
          _createVNode("strong", null, _toDisplayString(_ctx.room?.name), 1)
        ])
      ]),
      _createVNode(_component_Button, {
        label: "close",
        onClick: _ctx.handleHideDialog,
        disabled: _ctx.anyNameIsUnderComputation,
        class: "dialog-custom__close-button p-button-text"
      }, {
        default: _withCtx(() => [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InlineSvgScoped, {
              src: require(`@/assets/images/icons/icon-close.svg`)
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
          default: _withCtx(() => [
            _createVNode("ul", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.objectTypes, (objectType) => {
                return (_openBlock(), _createBlock("li", {
                  key: objectType.id,
                  name: objectType.id,
                  class: ["list-blocks__item", {
                            'is--empty': objectType.objects.length === 0,
                        }]
                }, [
                  _createVNode("header", _hoisted_6, [
                    _createVNode("span", _hoisted_7, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                        require(`@/assets/images/icons/${_ctx.getObjectIconFromType(
                                            objectType.type
                                        )}.svg`)
                                    
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("h3", _hoisted_8, _toDisplayString(_ctx.getObjectLabelFromType(objectType.type)), 1),
                    _createVNode(_component_Button, {
                      disabled: objectType.busy,
                      onClick: _withModifiers(() => _ctx.handleAddObject(objectType), ["stop"]),
                      class: "ml-auto p-button-rounded p-button-outlined py-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode("span", _hoisted_9, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                            require(`@/assets/images/icons/icon-plus-outline.svg`)
                                        ,
                            "aria-label": "icon-grid"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]),
                  _createVNode("main", _hoisted_11, [
                    (objectType.objects.length > 0)
                      ? (_openBlock(), _createBlock("ul", _hoisted_12, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(objectType.objects, (object, index) => {
                            return (_openBlock(), _createBlock(_component_NewRoomObject, {
                              key: object.id,
                              class: "d-flex align-items-center mt-3",
                              onObjectChange: _ctx.handleRoomObjectChange,
                              onRemoveObject: 
                                        () =>
                                            _ctx.handleObjectRemove(
                                                objectType,
                                                index
                                            )
                                    ,
                              room: _ctx.room,
                              "new-room-object": object,
                              plantId: _ctx.currentPlant?.desktopId,
                              "main-object-type": objectType.type
                            }, null, 8, ["onObjectChange", "onRemoveObject", "room", "new-room-object", "plantId", "main-object-type"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 10, ["name"]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode("footer", _hoisted_13, [
        _createVNode(_component_Button, {
          label: _ctx.buttonSubmitLabel,
          onClick: _ctx.handleButtonSubmitAction,
          disabled: _ctx.anyNameIsUnderComputation,
          class: "p-button-rounded p-button-raised p-button--m"
        }, null, 8, ["label", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["onHide", "visible"]))
}